import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment-timezone';
import { localize } from '../../i18n';


const TimeAge = function TimeAge(props) {
  let timeAge;
  const {
    time,
    affiliateTimeZone,
  } = props;

  const age = (val) => {
    let returnVal = props.t('unknown');
    if (!_.isNull(val)) {
      returnVal = moment(val).tz(affiliateTimeZone).fromNow();
    }
    return returnVal;
  };

  if (affiliateTimeZone) {
    timeAge = age(time);
  }
  return (
    <span>{timeAge}</span>
  );
};

TimeAge.propTypes = {
  time: PropTypes.string,
  affiliateTimeZone: PropTypes.string,
  t: PropTypes.func.isRequired,
};


const mapStateToProps = ({ session: { affiliate } }) => ({
  affiliateTimeZone: affiliate.attributes.timezone,
});

export default localize(connect(mapStateToProps)(TimeAge));



// WEBPACK FOOTER //
// ./src/components/Filters/TimeAge.js